import { Box } from '@mui/material'
import { blendsNestedTabs } from '../utils/consts'
import NestedTabsPage from '../layouts/NestedTabsPage'
import { Entity } from 'utils/hooks/usePermissions'
import { Navigate } from 'react-router-dom'
import { NoPermission } from 'pages/NoPermission/NoPermission'
import { useDataPermissions } from '../hooks/useDataPermissions'

const BlendsData = () => {
  // Check permissions using the custom hook
  const { hasPermission, redirectPath, showNoPermission } = useDataPermissions(
    Entity.WHEAT_CODE,
    'SHOW_WHEAT'
  )

  // Handle redirection or no permission
  if (!hasPermission) {
    if (redirectPath) {
      return <Navigate to={redirectPath} replace />
    }
    if (showNoPermission) {
      return <NoPermission />
    }
  }

  return (
    <Box>
      <Box>
        <NestedTabsPage tabsList={blendsNestedTabs} />
      </Box>
    </Box>
  )
}

export default BlendsData
